import { useEffect, useState, useRef } from "react";

// Subtle premium custom cursor (desktop only). Expands + shows "VIEW" over [data-cursor="view"].
export default function Cursor() {
  const dot = useRef(null);
  const [hovering, setHovering] = useState(false);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const isTouch = window.matchMedia("(pointer: coarse)").matches;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (isTouch || reduce) return;
    setEnabled(true);

    let raf;
    const pos = { x: -100, y: -100 };
    const cur = { x: -100, y: -100 };
    const move = (e) => {
      pos.x = e.clientX;
      pos.y = e.clientY;
      const t = e.target.closest("[data-cursor='view'], a, button");
      setHovering(!!(t && t.getAttribute("data-cursor") === "view"));
    };
    const loop = () => {
      cur.x += (pos.x - cur.x) * 0.18;
      cur.y += (pos.y - cur.y) * 0.18;
      if (dot.current) dot.current.style.transform = `translate(${cur.x}px, ${cur.y}px)`;
      raf = requestAnimationFrame(loop);
    };
    window.addEventListener("mousemove", move);
    raf = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener("mousemove", move);
      cancelAnimationFrame(raf);
    };
  }, []);

  if (!enabled) return null;

  return (
    <div ref={dot} className="pointer-events-none fixed left-0 top-0 z-[9998] hidden md:block" style={{ willChange: "transform" }}>
      <div
        className={`-translate-x-1/2 -translate-y-1/2 rounded-full border transition-all duration-300 ${
          hovering
            ? "h-16 w-16 border-pp-red bg-pp-red/90 text-white"
            : "h-3 w-3 border-pp-red bg-pp-red"
        } flex items-center justify-center`}
      >
        {hovering && <span className="text-[10px] font-semibold tracking-[0.2em]">VIEW</span>}
      </div>
    </div>
  );
}
